import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';
import api from '../utils/api';
import { FileText } from 'lucide-react';

const NotesModal = ({ isOpen, onClose, appointment, onNotes, user }) => {
  const [notes, setNotes] = useState(appointment?.remarks || '');

  const handleSaveNotes = () => {
    // Pass data to parent
    onNotes({
      appointmentId: appointment.id,
      remarks: notes
    });
  };

  if (!appointment) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-blue-600" />
            Appointment Notes
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="p-4 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>Patient:</strong> {appointment.patient_name}
            </p>
            <p className="text-sm text-blue-800">
              <strong>Service:</strong> {appointment.service_name}
            </p>
            <p className="text-sm text-blue-600">
              {appointment.scheduled_date}
              {appointment.scheduled_time && ` at ${appointment.scheduled_time}`}
            </p>
          </div>

          <div>
            <Label htmlFor="notes">Notes / Remarks</Label>
            <Textarea
              id="notes"
              data-testid="notes-textarea"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Enter appointment notes, remarks, or special instructions..."
              className="mt-2 min-h-[150px] resize-y"
            />
            <p className="text-xs text-gray-500 mt-1">
              {notes.length} characters
            </p>
          </div>

        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSaveNotes}
            data-testid="notes-save-button"
            className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700"
          >
            Save Notes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NotesModal;
